import { createTheme } from "@mui/material/styles";

// Typography settings matching existing app styles from Text.css
// Font family: Larsseit variants (Bold, Medium, Light)
const typography = {
  fontFamily: "Larsseit-Light, Larsseit, Arial, sans-serif",
  h1: {
    fontFamily: "Larsseit-Bold",
    fontSize: "30px",
    lineHeight: "30px",
  },
  h2: {
    fontFamily: "Larsseit-Bold",
    fontSize: "24px",
    lineHeight: "24px",
  },
  h3: {
    fontFamily: "Larsseit-Medium",
    fontSize: "20px",
    lineHeight: "20px",
  },
  h4: {
    fontFamily: "Larsseit-Light",
    fontSize: "16px",
    lineHeight: "24px",
  },
  h5: {
    fontFamily: "Larsseit-Bold",
    fontSize: "14px",
    lineHeight: "14px",
  },
  h6: {
    fontFamily: "Larsseit-Medium",
    fontSize: "14px",
    lineHeight: "14px",
  },
  subtitle1: {
    fontFamily: "Larsseit-Medium",
    fontSize: "16px",
    lineHeight: "24px",
  },
  subtitle2: {
    fontFamily: "Larsseit-Medium",
    fontSize: "14px",
    lineHeight: "22px",
  },
  body1: {
    fontFamily: "Larsseit-Light",
    fontSize: "16px",
    lineHeight: "24px",
  },
  body2: {
    fontFamily: "Larsseit-Light",
    fontSize: "14px",
    lineHeight: "22px",
  },
  caption: {
    fontFamily: "Larsseit-Light",
    fontSize: "12px",
    lineHeight: "20px",
  },
  button: {
    fontFamily: "Larsseit-Medium",
    fontSize: "14px",
    textTransform: "none",
  },
};

const muiTheme = createTheme({
  cssVariables: true,
  typography,

  // Component-specific configurations
  components: {
    // Select component styling
    MuiSelect: {
      defaultProps: {
        variant: "standard",
      },
      styleOverrides: {
        root: {
          fontSize: "14px",
        },
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: "standard",
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "Larsseit-Light",
          fontSize: "14px",
        },
      },
    },
    // Dialog styling
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontFamily: "Larsseit-Bold",
          fontSize: "24px",
          lineHeight: "24px",
          padding: "24px 24px 16px",
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: "16px 24px",
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: "16px 24px 24px",
        },
      },
    },
    // Button styling
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "Larsseit-Medium",
          fontSize: "14px",
          textTransform: "none",
        },
      },
    },
    // TextField styling
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: "Larsseit-Light",
          fontSize: "16px",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: "Larsseit-Light",
          fontSize: "16px",
        },
        input: {
          fontFamily: "Larsseit-Light",
          fontSize: "16px",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontFamily: "Larsseit-Light",
          fontSize: "16px",
        },
        input: {
          fontFamily: "Larsseit-Light",
          fontSize: "16px",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontFamily: "Larsseit-Light",
          fontSize: "12px",
        },
      },
    },
    // Stepper styling
    MuiStepLabel: {
      styleOverrides: {
        label: {
          fontFamily: "Larsseit-Medium",
          fontSize: "14px",
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          width: "28px",
          height: "28px",
        },
        text: {
          fontFamily: "Larsseit-Medium",
          fontSize: "14px",
        },
      },
    },
    // Alert styling
    MuiAlert: {
      styleOverrides: {
        message: {
          fontFamily: "Larsseit-Light",
          fontSize: "14px",
        },
      },
    },
  },
});

export default muiTheme;
